import { Table } from "components/Table";
import { QuestionnaireTableRow } from "core/types";
import { ThreeDotsAction } from "./TreeDotsAction";
import { columns } from "./columns";

const QuestionnaireTable = ({
  rows,
  onClick,
  patientUserId,
  patientName,
}: {
  rows: QuestionnaireTableRow[];
  onClick: (value: QuestionnaireTableRow) => void;
  patientUserId?: string;
  patientName?: string;
}) => {
  const data = rows.length > 0 ? rows : emptyState;

  return (
    <Table
      data={data}
      columns={columns}
      onRowClick={onClick}
      rowAction={(row) => (
        <ThreeDotsAction
          row={row}
          patientUserId={patientUserId}
          patientName={patientName}
        />
      )}
    />
  );
};

const emptyState: QuestionnaireTableRow[] = [
  {
    title: { value: "--", status: "" },
    dateSent: "--",
    sentBy: "--",
    score: undefined,
    dateCompleted: "--",
    clinicalId: "",
    isNew: false,
    id: "",
  },
];

export default QuestionnaireTable;
